module.exports = __webpack_public_path__ + "img/eschenbach_2015_ref.556d5771.jpg";